import { Component, Vue } from 'vue-property-decorator';
import { HSLColor } from '../types/color';

interface ColorFlashInfo {
  background: string;
  text: string;
}

const setClipboardData = (event: ClipboardEvent, value: string) => {
  if (event.clipboardData) {
    event.clipboardData.setData('Text', value);
  }
  event.preventDefault();
};

@Component
export default class Clipboard extends Vue {
  copyValue(color: HSLColor): void {
    const value: string = this.transformColorForCopy(color);

    document.addEventListener('copy', (event: ClipboardEvent) => setClipboardData(event, value));
    document.execCommand('Copy');
    document.removeEventListener('copy', () => setClipboardData);

    this.flashCopiedAlert({
      background: value,
      text: value,
    });
  }

  transformColorForCopy = (color: HSLColor): string => {
    let value;
    if (typeof color !== 'string') {
      value = `hsl(${color.h}, ${color.s}%, ${color.l}%)`;
    } else {
      value = color;
    }
    return value;
  }

  flashCopiedAlert(color: ColorFlashInfo) {
    this.$store.commit('setCopiedColor', color);
    setTimeout(() => { this.$store.commit('setCopiedColor', null); }, 600);
  }
}
